/* Minimal Facebook Pixel wrapper */

declare global {
  interface Window {
    fbq?: any;
  }
}

export const track = (
  eventName: string,
  params?: Record<string, any>,
  options?: { eventID?: string }
) => {
  try {
    if (typeof window === "undefined" || !window.fbq) return;
    if (options?.eventID) {
      window.fbq("track", eventName, params || {}, {
        eventID: options.eventID,
      });
    } else {
      window.fbq("track", eventName, params || {});
    }
  } catch (error) {
    console.warn("Error tracking event:", eventName, error);
  }
};

export const trackCustom = (
  eventName: string,
  params?: Record<string, any>,
  options?: { eventID?: string }
) => {
  try {
    if (typeof window === "undefined" || !window.fbq) return;
    if (options?.eventID) {
      window.fbq("trackCustom", eventName, params || {}, {
        eventID: options.eventID,
      });
    } else {
      window.fbq("trackCustom", eventName, params || {});
    }
  } catch (error) {
    console.warn("Error tracking custom event:", eventName, error);
  }
};

